export type StreamErrorClassification = "aborted" | "network" | "unknown";

const NETWORK_ERROR_MESSAGES = new Set([
    "network error",
    "load failed",
    "failed to fetch",
    "networkerror when attempting to fetch resource.",
]);

export const classifyStreamError = (
    error: unknown
): StreamErrorClassification => {
    if (!(error instanceof Error)) {
        return "unknown";
    }

    if (error.name === "AbortError") {
        return "aborted";
    }

    if (
        error instanceof TypeError &&
        NETWORK_ERROR_MESSAGES.has(error.message.trim().toLowerCase())
    ) {
        return "network";
    }

    return "unknown";
};
